import { render, staticRenderFns } from "./ComplementoCartaPorteTrasladoPdf.vue?vue&type=template&id=28727f53&"
import script from "./ComplementoCartaPorteTrasladoPdf.vue?vue&type=script&lang=js&"
export * from "./ComplementoCartaPorteTrasladoPdf.vue?vue&type=script&lang=js&"
import style0 from "./ComplementoCartaPorteTrasladoPdf.vue?vue&type=style&index=0&id=28727f53&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports